<template>
    <b-container>
        <b-row>
            <b-col lg="6" md="8" class="about">
                <div class="content">
                    <h1>
                        Hosting
                    </h1>
                    <p>
                        We provide tailored hosting solutions depending on specific business cases, such as websites, E-Commerce platforms, E-Learning solutions and many others that need a house in the cloud to reside in.
                    </p>
                    <p>
                        Specially focused on speed and outstanding performance - with a reasonable pricing assessment - we provide our customers with the best available and state-of-the-art solutions for cloud hosting.
                    </p>
                    <p>
                        We can also provide with email for multiple mailboxes in a corporation, and newsletter solutions for integration with websites or for online marketing.
                    </p>
                </div>
            </b-col>
            <b-col lg="6" md="4" class="image">
                <img src="../assets/img/hosting.svg" alt="Hosting">
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
  export default {
    name: 'Hosting'
  }
</script>

<style scoped>
</style>